import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/CREATEORDER`;

export const REDUCER_NAME = 'CREATEORDER';

export const CREATE_URL = `${OPERATIONS_EDGE}/api/masheed/single-sales-order/create-shipments`;
export const CREATE_EX_WORK_URL = `${OPERATIONS_EDGE}/api/masheed/exwork-sales-order/create-shipments`;
export const CREATE_FORECAST_URL = `${OPERATIONS_EDGE}/api/masheed/single-forecast-sales-order/create-shipments`;

// export const TRUCK_TYPE_TO_CATEGORY = {
//   'Bulker': ['BLC-Bulk', 'Type-II Bulk', 'Type-III Bulk', 'Cement Ash', 'White Cem-I Bags', 'White Cem-II Bags'
// };

export const ROUTES = {
  ROOT: '/shipment/create-order',
};
